/* eslint-disable */

// This file was automatically generated by `typescript.ts`.
// Do not modify it by hand. Instead, modify the source `.schema.yaml` files
// in the `schema` directory and run `npm run build:ts` to regenerate it.

// Remove properties from an Object if their values is undefined
const compact = <O extends object>(o: O): O =>
  Object.entries(o).reduce(
    (compactedO: O, [k, v]) =>
      v === undefined ? compactedO : { ...compactedO, [k]: v },
    {} as O
  )

export interface Types {
  ArrayValidator: ArrayValidator
  Article: Article
  AudioObject: AudioObject
  BlockContent: BlockContent
  BooleanValidator: BooleanValidator
  Brand: Brand
  Cite: Cite
  CiteGroup: CiteGroup
  Code: Code
  CodeBlock: CodeBlock
  CodeBlockTypes: CodeBlockTypes
  CodeChunk: CodeChunk
  CodeError: CodeError
  CodeExpression: CodeExpression
  CodeFragment: CodeFragment
  CodeFragmentTypes: CodeFragmentTypes
  CodeTypes: CodeTypes
  Collection: Collection
  ConstantValidator: ConstantValidator
  ContactPoint: ContactPoint
  CreativeWork: CreativeWork
  CreativeWorkTypes: CreativeWorkTypes
  Datatable: Datatable
  DatatableColumn: DatatableColumn
  Date: Date
  Delete: Delete
  Emphasis: Emphasis
  Entity: Entity
  EntityTypes: EntityTypes
  EnumValidator: EnumValidator
  Figure: Figure
  Function: Function
  Grant: Grant
  GrantTypes: GrantTypes
  Heading: Heading
  ImageObject: ImageObject
  Include: Include
  InlineContent: InlineContent
  IntegerValidator: IntegerValidator
  Link: Link
  List: List
  ListItem: ListItem
  Mark: Mark
  MarkTypes: MarkTypes
  Math: Math
  MathBlock: MathBlock
  MathFragment: MathFragment
  MathTypes: MathTypes
  MediaObject: MediaObject
  MediaObjectTypes: MediaObjectTypes
  MonetaryGrant: MonetaryGrant
  Node: Node
  NumberValidator: NumberValidator
  NumberValidatorTypes: NumberValidatorTypes
  Organization: Organization
  Paragraph: Paragraph
  Parameter: Parameter
  Periodical: Periodical
  Person: Person
  Product: Product
  PropertyValue: PropertyValue
  PublicationIssue: PublicationIssue
  PublicationVolume: PublicationVolume
  Quote: Quote
  QuoteBlock: QuoteBlock
  SoftwareApplication: SoftwareApplication
  SoftwareEnvironment: SoftwareEnvironment
  SoftwareSession: SoftwareSession
  SoftwareSourceCode: SoftwareSourceCode
  StringValidator: StringValidator
  Strong: Strong
  Subscript: Subscript
  Superscript: Superscript
  Table: Table
  TableCell: TableCell
  TableRow: TableRow
  ThematicBreak: ThematicBreak
  Thing: Thing
  ThingTypes: ThingTypes
  TupleValidator: TupleValidator
  ValidatorTypes: ValidatorTypes
  Variable: Variable
  VariableTypes: VariableTypes
  VideoObject: VideoObject
  VolumeMount: VolumeMount
}

/**
 * The most simple compound (ie. non-atomic like `number`, `string` etc) type.
 */
export interface Entity {
  type:
    | 'Entity'
    | 'ArrayValidator'
    | 'Article'
    | 'AudioObject'
    | 'BooleanValidator'
    | 'Brand'
    | 'Cite'
    | 'CiteGroup'
    | 'Code'
    | 'CodeBlock'
    | 'CodeChunk'
    | 'CodeError'
    | 'CodeExpression'
    | 'CodeFragment'
    | 'Collection'
    | 'ConstantValidator'
    | 'ContactPoint'
    | 'CreativeWork'
    | 'Datatable'
    | 'DatatableColumn'
    | 'Date'
    | 'Delete'
    | 'Emphasis'
    | 'EnumValidator'
    | 'Figure'
    | 'Function'
    | 'Grant'
    | 'Heading'
    | 'ImageObject'
    | 'Include'
    | 'IntegerValidator'
    | 'Link'
    | 'List'
    | 'ListItem'
    | 'Mark'
    | 'Math'
    | 'MathBlock'
    | 'MathFragment'
    | 'MediaObject'
    | 'MonetaryGrant'
    | 'NumberValidator'
    | 'Organization'
    | 'Paragraph'
    | 'Parameter'
    | 'Periodical'
    | 'Person'
    | 'Product'
    | 'PropertyValue'
    | 'PublicationIssue'
    | 'PublicationVolume'
    | 'Quote'
    | 'QuoteBlock'
    | 'SoftwareApplication'
    | 'SoftwareEnvironment'
    | 'SoftwareSession'
    | 'SoftwareSourceCode'
    | 'StringValidator'
    | 'Strong'
    | 'Subscript'
    | 'Superscript'
    | 'Table'
    | 'TableCell'
    | 'TableRow'
    | 'ThematicBreak'
    | 'Thing'
    | 'TupleValidator'
    | 'Variable'
    | 'VideoObject'
    | 'VolumeMount'
  id?: string
  meta?: { [key: string]: any }
}

/**
 * Create a `Entity` node
 * @param props Object containing Entity schema properties as key/value pairs
 * @returns {Entity} Entity schema node
 */
export const entity = (props: Omit<Entity, 'type'> = {}): Entity => ({
  ...compact(props),
  type: 'Entity'
})

/**
 * A validator specifying constraints on an array node.
 */
export interface ArrayValidator extends Entity {
  type: 'ArrayValidator'
  contains?: ValidatorTypes
  items?: ValidatorTypes
  maxItems?: number
  minItems?: number
  uniqueItems?: boolean
}

/**
 * Create a `ArrayValidator` node
 * @param props Object containing ArrayValidator schema properties as key/value pairs
 * @returns {ArrayValidator} ArrayValidator schema node
 */
export const arrayValidator = (
  props: Omit<ArrayValidator, 'type'> = {}
): ArrayValidator => ({
  ...compact(props),
  type: 'ArrayValidator'
})

/**
 * A schema specifying that a node must be a boolean value.
 */
export interface BooleanValidator extends Entity {
  type: 'BooleanValidator'
}

/**
 * Create a `BooleanValidator` node
 * @param props Object containing BooleanValidator schema properties as key/value pairs
 * @returns {BooleanValidator} BooleanValidator schema node
 */
export const booleanValidator = (
  props: Omit<BooleanValidator, 'type'> = {}
): BooleanValidator => ({
  ...compact(props),
  type: 'BooleanValidator'
})

/**
 * A reference to a CreativeWork that is cited in another CreativeWork.
 */
export interface Cite extends Entity {
  type: 'Cite'
  target: string
  citationMode?: 'normal' | 'suppressAuthor'
  content?: Array<InlineContent>
  pageEnd?: string | number
  pageStart?: string | number
  pagination?: string
  prefix?: string
  suffix?: string
}

/**
 * Create a `Cite` node
 * @param props Object containing Cite schema properties as key/value pairs
 * @returns {Cite} Cite schema node
 */
export const cite = (props: Omit<Cite, 'type'>): Cite => ({
  ...compact(props),
  type: 'Cite'
})

/**
 * A group of `Cite` nodes
 */
export interface CiteGroup extends Entity {
  type: 'CiteGroup'
  items: Array<Cite>
}

/**
 * Create a `CiteGroup` node
 * @param props Object containing CiteGroup schema properties as key/value pairs
 * @returns {CiteGroup} CiteGroup schema node
 */
export const citeGroup = (props: Omit<CiteGroup, 'type'>): CiteGroup => ({
  ...compact(props),
  type: 'CiteGroup'
})

/**
 * Base type for code nodes e.g. `CodeBlock`, `CodeExpression`.
 */
export interface Code extends Entity {
  type: 'Code' | 'CodeBlock' | 'CodeChunk' | 'CodeExpression' | 'CodeFragment'
  text: string
  format?: string
  programmingLanguage?: string
}

/**
 * Create a `Code` node
 * @param props Object containing Code schema properties as key/value pairs
 * @returns {Code} Code schema node
 */
export const code = (props: Omit<Code, 'type'>): Code => ({
  ...compact(props),
  type: 'Code'
})

/**
 * A code block.
 */
export interface CodeBlock extends Code {
  type: 'CodeBlock' | 'CodeChunk'
  exportFrom?: string
  importTo?: string
}

/**
 * Create a `CodeBlock` node
 * @param props Object containing CodeBlock schema properties as key/value pairs
 * @returns {CodeBlock} CodeBlock schema node
 */
export const codeBlock = (props: Omit<CodeBlock, 'type'>): CodeBlock => ({
  ...compact(props),
  type: 'CodeBlock'
})

/**
 * A executable chunk of code.
 */
export interface CodeChunk extends CodeBlock {
  type: 'CodeChunk'
  alters?: Array<string>
  assigns?: Array<string | Variable>
  declares?: Array<string | Variable | Function>
  duration?: number
  errors?: Array<CodeError>
  imports?: Array<string | SoftwareSourceCode | SoftwareApplication>
  outputs?: Array<Node>
  reads?: Array<string>
  uses?: Array<string | Variable>
}

/**
 * Create a `CodeChunk` node
 * @param props Object containing CodeChunk schema properties as key/value pairs
 * @returns {CodeChunk} CodeChunk schema node
 */
export const codeChunk = (props: Omit<CodeChunk, 'type'>): CodeChunk => ({
  ...compact(props),
  type: 'CodeChunk'
})

/**
 * Inline code.
 */
export interface CodeFragment extends Code {
  type: 'CodeFragment' | 'CodeExpression'
}

/**
 * Create a `CodeFragment` node
 * @param props Object containing CodeFragment schema properties as key/value pairs
 * @returns {CodeFragment} CodeFragment schema node
 */
export const codeFragment = (
  props: Omit<CodeFragment, 'type'>
): CodeFragment => ({
  ...compact(props),
  type: 'CodeFragment'
})

/**
 * An expression defined in programming language source code.
 */
export interface CodeExpression extends CodeFragment {
  type: 'CodeExpression'
  errors?: Array<CodeError>
  output?: Node
}

/**
 * Create a `CodeExpression` node
 * @param props Object containing CodeExpression schema properties as key/value pairs
 * @returns {CodeExpression} CodeExpression schema node
 */
export const codeExpression = (
  props: Omit<CodeExpression, 'type'>
): CodeExpression => ({
  ...compact(props),
  type: 'CodeExpression'
})

/**
 * An error that occurred when parsing, compiling or executing a Code node.
 */
export interface CodeError extends Entity {
  type: 'CodeError'
  errorMessage?: string
  errorType?: string
  stackTrace?: string
}

/**
 * Create a `CodeError` node
 * @param props Object containing CodeError schema properties as key/value pairs
 * @returns {CodeError} CodeError schema node
 */
export const codeError = (props: Omit<CodeError, 'type'> = {}): CodeError => ({
  ...compact(props),
  type: 'CodeError'
})

/**
 * A validator specifying a constant value that a node must have.
 */
export interface ConstantValidator extends Entity {
  type: 'ConstantValidator'
  value?: Node
}

/**
 * Create a `ConstantValidator` node
 * @param props Object containing ConstantValidator schema properties as key/value pairs
 * @returns {ConstantValidator} ConstantValidator schema node
 */
export const constantValidator = (
  props: Omit<ConstantValidator, 'type'> = {}
): ConstantValidator => ({
  ...compact(props),
  type: 'ConstantValidator'
})

/**
 * A date encoded as a ISO 8601 string.
 */
export interface Date extends Entity {
  type: 'Date'
  value: string
}

/**
 * Create a `Date` node
 * @param props Object containing Date schema properties as key/value pairs
 * @returns {Date} Date schema node
 */
export const date = (props: Omit<Date, 'type'>): Date => ({
  ...compact(props),
  type: 'Date'
})

/**
 * A base class for nodes that mark some other inline content
 * in some way (e.g. as being emphasised, or quoted).
 */
export interface Mark extends Entity {
  type:
    | 'Mark'
    | 'Delete'
    | 'Emphasis'
    | 'Quote'
    | 'Strong'
    | 'Subscript'
    | 'Superscript'
  content: Array<InlineContent>
}

/**
 * Create a `Mark` node
 * @param props Object containing Mark schema properties as key/value pairs
 * @returns {Mark} Mark schema node
 */
export const mark = (props: Omit<Mark, 'type'>): Mark => ({
  ...compact(props),
  type: 'Mark'
})

/**
 * Content that is marked for deletion
 */
export interface Delete extends Mark {
  type: 'Delete'
}

/**
 * Create a `Delete` node
 * @param props Object containing Delete schema properties as key/value pairs
 * @returns {Delete} Delete schema node
 */
export const del = (props: Omit<Delete, 'type'>): Delete => ({
  ...compact(props),
  type: 'Delete'
})

/**
 * Emphasised content.
 */
export interface Emphasis extends Mark {
  type: 'Emphasis'
}

/**
 * Create a `Emphasis` node
 * @param props Object containing Emphasis schema properties as key/value pairs
 * @returns {Emphasis} Emphasis schema node
 */
export const emphasis = (props: Omit<Emphasis, 'type'>): Emphasis => ({
  ...compact(props),
  type: 'Emphasis'
})

/**
 * The most generic type of item.
 */
export interface Thing extends Entity {
  type:
    | 'Thing'
    | 'Article'
    | 'AudioObject'
    | 'Brand'
    | 'Collection'
    | 'ContactPoint'
    | 'CreativeWork'
    | 'Datatable'
    | 'DatatableColumn'
    | 'Figure'
    | 'Grant'
    | 'ImageObject'
    | 'MediaObject'
    | 'MonetaryGrant'
    | 'Organization'
    | 'Periodical'
    | 'Person'
    | 'Product'
    | 'PropertyValue'
    | 'PublicationIssue'
    | 'PublicationVolume'
    | 'SoftwareApplication'
    | 'SoftwareEnvironment'
    | 'SoftwareSession'
    | 'SoftwareSourceCode'
    | 'Table'
    | 'VideoObject'
    | 'VolumeMount'
  alternateNames?: Array<string>
  description?: string | Array<Node>
  identifiers?: Array<string | PropertyValue>
  name?: string
  url?: string
}

/**
 * Create a `Thing` node
 * @param props Object containing Thing schema properties as key/value pairs
 * @returns {Thing} Thing schema node
 */
export const thing = (props: Omit<Thing, 'type'> = {}): Thing => ({
  ...compact(props),
  type: 'Thing'
})

/**
 * A brand used by an organization or person for labeling a product,
 * product group, or similar.
 */
export interface Brand extends Thing {
  type: 'Brand'
  name: string
  logo?: string | ImageObject
  reviews?: Array<string>
}

/**
 * Create a `Brand` node
 * @param props Object containing Brand schema properties as key/value pairs
 * @returns {Brand} Brand schema node
 */
export const brand = (props: Omit<Brand, 'type'>): Brand => ({
  ...compact(props),
  type: 'Brand'
})

/**
 * A contact point, for example, a R&D department.
 */
export interface ContactPoint extends Thing {
  type: 'ContactPoint'
  availableLanguages?: Array<string>
  emails?: Array<string>
  telephoneNumbers?: Array<string>
}

/**
 * Create a `ContactPoint` node
 * @param props Object containing ContactPoint schema properties as key/value pairs
 * @returns {ContactPoint} ContactPoint schema node
 */
export const contactPoint = (
  props: Omit<ContactPoint, 'type'> = {}
): ContactPoint => ({
  ...compact(props),
  type: 'ContactPoint'
})

/**
 * A creative work, including books, movies, photographs, software programs, etc.
 */
export interface CreativeWork extends Thing {
  type:
    | 'CreativeWork'
    | 'Article'
    | 'AudioObject'
    | 'Collection'
    | 'Datatable'
    | 'Figure'
    | 'ImageObject'
    | 'MediaObject'
    | 'Periodical'
    | 'PublicationIssue'
    | 'PublicationVolume'
    | 'SoftwareApplication'
    | 'SoftwareSourceCode'
    | 'Table'
    | 'VideoObject'
  authors?: Array<Person | Organization>
  content?: Array<Node>
  dateAccepted?: Date | string
  dateCreated?: Date | string
  dateModified?: Date | string
  datePublished?: Date | string
  dateReceived?: Date | string
  editors?: Array<Person>
  fundedBy?: Array<Grant | MonetaryGrant>
  funders?: Array<Person | Organization>
  isPartOf?: CreativeWorkTypes
  keywords?: Array<string>
  licenses?: Array<string | CreativeWorkTypes>
  parts?: Array<CreativeWorkTypes>
  publisher?: Person | Organization
  references?: Array<string | CreativeWorkTypes>
  text?: string
  title?: string | Array<Node>
  version?: string | number
}

/**
 * Create a `CreativeWork` node
 * @param props Object containing CreativeWork schema properties as key/value pairs
 * @returns {CreativeWork} CreativeWork schema node
 */
export const creativeWork = (
  props: Omit<CreativeWork, 'type'> = {}
): CreativeWork => ({
  ...compact(props),
  type: 'CreativeWork'
})

/**
 * An article, including news and scholarly articles.
 */
export interface Article extends CreativeWork {
  type: 'Article'
}

/**
 * Create a `Article` node
 * @param props Object containing Article schema properties as key/value pairs
 * @returns {Article} Article schema node
 */
export const article = (props: Omit<Article, 'type'> = {}): Article => ({
  ...compact(props),
  type: 'Article'
})

/**
 * A created collection of CreativeWorks or other artefacts.
 */
export interface Collection extends CreativeWork {
  type: 'Collection'
  parts: Array<CreativeWorkTypes>
}

/**
 * Create a `Collection` node
 * @param props Object containing Collection schema properties as key/value pairs
 * @returns {Collection} Collection schema node
 */
export const collection = (props: Omit<Collection, 'type'>): Collection => ({
  ...compact(props),
  type: 'Collection'
})

/**
 * A table of data.
 */
export interface Datatable extends CreativeWork {
  type: 'Datatable'
  columns: Array<DatatableColumn>
}

/**
 * Create a `Datatable` node
 * @param props Object containing Datatable schema properties as key/value pairs
 * @returns {Datatable} Datatable schema node
 */
export const datatable = (props: Omit<Datatable, 'type'>): Datatable => ({
  ...compact(props),
  type: 'Datatable'
})

/**
 * A media object, such as an image, video, or audio object embedded in a web page or a
 * downloadable dataset.
 */
export interface MediaObject extends CreativeWork {
  type: 'MediaObject' | 'AudioObject' | 'ImageObject' | 'VideoObject'
  contentUrl: string
  bitrate?: number
  contentSize?: number
  embedUrl?: string
  format?: string
}

/**
 * Create a `MediaObject` node
 * @param props Object containing MediaObject schema properties as key/value pairs
 * @returns {MediaObject} MediaObject schema node
 */
export const mediaObject = (props: Omit<MediaObject, 'type'>): MediaObject => ({
  ...compact(props),
  type: 'MediaObject'
})

/**
 * An audio file
 */
export interface AudioObject extends MediaObject {
  type: 'AudioObject'
  caption?: string
  transcript?: string
}

/**
 * Create a `AudioObject` node
 * @param props Object containing AudioObject schema properties as key/value pairs
 * @returns {AudioObject} AudioObject schema node
 */
export const audioObject = (props: Omit<AudioObject, 'type'>): AudioObject => ({
  ...compact(props),
  type: 'AudioObject'
})

/**
 * A column of data within a Datatable.
 */
export interface DatatableColumn extends Thing {
  type: 'DatatableColumn'
  name: string
  values: Array<any>
  validator?: ArrayValidator
}

/**
 * Create a `DatatableColumn` node
 * @param props Object containing DatatableColumn schema properties as key/value pairs
 * @returns {DatatableColumn} DatatableColumn schema node
 */
export const datatableColumn = (
  props: Omit<DatatableColumn, 'type'>
): DatatableColumn => ({
  ...compact(props),
  type: 'DatatableColumn'
})

/**
 * A schema specifying that a node must be one of several values.
 */
export interface EnumValidator extends Entity {
  type: 'EnumValidator'
  values?: Array<Node>
}

/**
 * Create a `EnumValidator` node
 * @param props Object containing EnumValidator schema properties as key/value pairs
 * @returns {EnumValidator} EnumValidator schema node
 */
export const enumValidator = (
  props: Omit<EnumValidator, 'type'> = {}
): EnumValidator => ({
  ...compact(props),
  type: 'EnumValidator'
})

/**
 * Encapsulates one or more images, videos, tables, etc, and provides captions and labels for them.
 */
export interface Figure extends CreativeWork {
  type: 'Figure'
  caption?: Array<Node>
  label?: string
}

/**
 * Create a `Figure` node
 * @param props Object containing Figure schema properties as key/value pairs
 * @returns {Figure} Figure schema node
 */
export const figure = (props: Omit<Figure, 'type'> = {}): Figure => ({
  ...compact(props),
  type: 'Figure'
})

/**
 * A function with a name, which might take Parameters and return a value of a certain type.
 */
export interface Function extends Entity {
  type: 'Function'
  name?: string
  parameters?: Array<Parameter>
  returns?: ValidatorTypes
}

/**
 * Create a `Function` node
 * @param props Object containing Function schema properties as key/value pairs
 * @returns {Function} Function schema node
 */
export const function_ = (props: Omit<Function, 'type'> = {}): Function => ({
  ...compact(props),
  type: 'Function'
})

/**
 * A grant, typically financial or otherwise quantifiable, of resources.
 */
export interface Grant extends Thing {
  type: 'Grant' | 'MonetaryGrant'
  fundedItems?: Array<Thing>
  sponsors?: Array<Person | Organization>
}

/**
 * Create a `Grant` node
 * @param props Object containing Grant schema properties as key/value pairs
 * @returns {Grant} Grant schema node
 */
export const grant = (props: Omit<Grant, 'type'> = {}): Grant => ({
  ...compact(props),
  type: 'Grant'
})

/**
 * Heading
 */
export interface Heading extends Entity {
  type: 'Heading'
  content: Array<InlineContent>
  depth?: number
}

/**
 * Create a `Heading` node
 * @param props Object containing Heading schema properties as key/value pairs
 * @returns {Heading} Heading schema node
 */
export const heading = (props: Omit<Heading, 'type'>): Heading => ({
  ...compact(props),
  type: 'Heading'
})

/**
 * An image file.
 */
export interface ImageObject extends MediaObject {
  type: 'ImageObject'
  caption?: string
  thumbnail?: ImageObject
}

/**
 * Create a `ImageObject` node
 * @param props Object containing ImageObject schema properties as key/value pairs
 * @returns {ImageObject} ImageObject schema node
 */
export const imageObject = (props: Omit<ImageObject, 'type'>): ImageObject => ({
  ...compact(props),
  type: 'ImageObject'
})

/**
 * A directive to include content from an external source (e.g. file, URL) or content.
 */
export interface Include extends Entity {
  type: 'Include'
  source: string
  content?: Array<BlockContent>
  format?: string
}

/**
 * Create a `Include` node
 * @param props Object containing Include schema properties as key/value pairs
 * @returns {Include} Include schema node
 */
export const include = (props: Omit<Include, 'type'>): Include => ({
  ...compact(props),
  type: 'Include'
})

/**
 * A validator specifying the constraints on a numeric node.
 */
export interface NumberValidator extends Entity {
  type: 'NumberValidator' | 'IntegerValidator'
  exclusiveMaximum?: number
  exclusiveMinimum?: number
  maximum?: number
  minimum?: number
  multipleOf?: number
}

/**
 * Create a `NumberValidator` node
 * @param props Object containing NumberValidator schema properties as key/value pairs
 * @returns {NumberValidator} NumberValidator schema node
 */
export const numberValidator = (
  props: Omit<NumberValidator, 'type'> = {}
): NumberValidator => ({
  ...compact(props),
  type: 'NumberValidator'
})

/**
 * A validator specifying the constraints on an integer node.
 */
export interface IntegerValidator extends NumberValidator {
  type: 'IntegerValidator'
}

/**
 * Create a `IntegerValidator` node
 * @param props Object containing IntegerValidator schema properties as key/value pairs
 * @returns {IntegerValidator} IntegerValidator schema node
 */
export const integerValidator = (
  props: Omit<IntegerValidator, 'type'> = {}
): IntegerValidator => ({
  ...compact(props),
  type: 'IntegerValidator'
})

/**
 * A hyperlink to other pages, sections within the same document, resources, or any URL.
 */
export interface Link extends Entity {
  type: 'Link'
  content: Array<InlineContent>
  target: string
  exportFrom?: string
  importTo?: string
  relation?: string
  title?: string
}

/**
 * Create a `Link` node
 * @param props Object containing Link schema properties as key/value pairs
 * @returns {Link} Link schema node
 */
export const link = (props: Omit<Link, 'type'>): Link => ({
  ...compact(props),
  type: 'Link'
})

/**
 * A list of items.
 */
export interface List extends Entity {
  type: 'List'
  items: Array<ListItem>
  order?: 'ascending' | 'descending' | 'unordered'
}

/**
 * Create a `List` node
 * @param props Object containing List schema properties as key/value pairs
 * @returns {List} List schema node
 */
export const list = (props: Omit<List, 'type'>): List => ({
  ...compact(props),
  type: 'List'
})

/**
 * A single item in a list.
 */
export interface ListItem extends Entity {
  type: 'ListItem'
  content: Array<Node>
  checked?: boolean
}

/**
 * Create a `ListItem` node
 * @param props Object containing ListItem schema properties as key/value pairs
 * @returns {ListItem} ListItem schema node
 */
export const listItem = (props: Omit<ListItem, 'type'>): ListItem => ({
  ...compact(props),
  type: 'ListItem'
})

/**
 * A mathematical variable or equation.
 */
export interface Math extends Entity {
  type: 'Math' | 'MathBlock' | 'MathFragment'
  text: string
  errors?: Array<string>
  mathLanguage?: string
}

/**
 * Create a `Math` node
 * @param props Object containing Math schema properties as key/value pairs
 * @returns {Math} Math schema node
 */
export const math = (props: Omit<Math, 'type'>): Math => ({
  ...compact(props),
  type: 'Math'
})

/**
 * A block of math, e.g an equation, to be treated as block content.
 */
export interface MathBlock extends Math {
  type: 'MathBlock'
}

/**
 * Create a `MathBlock` node
 * @param props Object containing MathBlock schema properties as key/value pairs
 * @returns {MathBlock} MathBlock schema node
 */
export const mathBlock = (props: Omit<MathBlock, 'type'>): MathBlock => ({
  ...compact(props),
  type: 'MathBlock'
})

/**
 * A fragment of math, e.g a variable name, to be treated as inline content.
 */
export interface MathFragment extends Math {
  type: 'MathFragment'
}

/**
 * Create a `MathFragment` node
 * @param props Object containing MathFragment schema properties as key/value pairs
 * @returns {MathFragment} MathFragment schema node
 */
export const mathFragment = (
  props: Omit<MathFragment, 'type'>
): MathFragment => ({
  ...compact(props),
  type: 'MathFragment'
})

/**
 * A monetary grant.
 */
export interface MonetaryGrant extends Grant {
  type: 'MonetaryGrant'
  amounts?: number
  funders?: Array<Person | Organization>
}

/**
 * Create a `MonetaryGrant` node
 * @param props Object containing MonetaryGrant schema properties as key/value pairs
 * @returns {MonetaryGrant} MonetaryGrant schema node
 */
export const monetaryGrant = (
  props: Omit<MonetaryGrant, 'type'> = {}
): MonetaryGrant => ({
  ...compact(props),
  type: 'MonetaryGrant'
})

/**
 * An organization such as a school, NGO, corporation, club, etc.
 */
export interface Organization extends Thing {
  type: 'Organization'
  address?: string
  brands?: Array<Brand>
  contactPoints?: Array<ContactPoint>
  departments?: Array<Organization>
  funders?: Array<Organization | Person>
  legalName?: string
  logo?: string | ImageObject
  parentOrganization?: Organization
}

/**
 * Create a `Organization` node
 * @param props Object containing Organization schema properties as key/value pairs
 * @returns {Organization} Organization schema node
 */
export const organization = (
  props: Omit<Organization, 'type'> = {}
): Organization => ({
  ...compact(props),
  type: 'Organization'
})

/**
 * Paragraph
 */
export interface Paragraph extends Entity {
  type: 'Paragraph'
  content: Array<InlineContent>
}

/**
 * Create a `Paragraph` node
 * @param props Object containing Paragraph schema properties as key/value pairs
 * @returns {Paragraph} Paragraph schema node
 */
export const paragraph = (props: Omit<Paragraph, 'type'>): Paragraph => ({
  ...compact(props),
  type: 'Paragraph'
})

/**
 * A variable representing a name / value pair.
 */
export interface Variable extends Entity {
  type: 'Variable' | 'Parameter'
  name: string
  readonly?: boolean
  validator?: ValidatorTypes
  value?: Node
}

/**
 * Create a `Variable` node
 * @param props Object containing Variable schema properties as key/value pairs
 * @returns {Variable} Variable schema node
 */
export const variable = (props: Omit<Variable, 'type'>): Variable => ({
  ...compact(props),
  type: 'Variable'
})

/**
 * A parameter that can be set and used in evaluated code.
 */
export interface Parameter extends Variable {
  type: 'Parameter'
  default?: Node
  extends?: boolean
  repeats?: boolean
  required?: boolean
}

/**
 * Create a `Parameter` node
 * @param props Object containing Parameter schema properties as key/value pairs
 * @returns {Parameter} Parameter schema node
 */
export const parameter = (props: Omit<Parameter, 'type'>): Parameter => ({
  ...compact(props),
  type: 'Parameter'
})

/**
 * A periodical publication.
 */
export interface Periodical extends CreativeWork {
  type: 'Periodical'
  dateEnd?: Date | string
  dateStart?: Date | string
  issns?: Array<string>
}

/**
 * Create a `Periodical` node
 * @param props Object containing Periodical schema properties as key/value pairs
 * @returns {Periodical} Periodical schema node
 */
export const periodical = (
  props: Omit<Periodical, 'type'> = {}
): Periodical => ({
  ...compact(props),
  type: 'Periodical'
})

/**
 * A person (alive, dead, undead, or fictional).
 */
export interface Person extends Thing {
  type: 'Person'
  address?: string
  affiliations?: Array<Organization>
  emails?: Array<string>
  familyNames?: Array<string>
  funders?: Array<Organization | Person>
  givenNames?: Array<string>
  honorificPrefix?: string
  honorificSuffix?: string
  jobTitle?: string
  memberOf?: Array<Organization>
  telephoneNumbers?: Array<string>
}

/**
 * Create a `Person` node
 * @param props Object containing Person schema properties as key/value pairs
 * @returns {Person} Person schema node
 */
export const person = (props: Omit<Person, 'type'> = {}): Person => ({
  ...compact(props),
  type: 'Person'
})

/**
 * Any offered product or service. For example, a pair of shoes;
 * a haircut; or an episode of a TV show streamed online.
 */
export interface Product extends Thing {
  type: 'Product'
  brands?: Array<Brand>
  logo?: string | ImageObject
  productID?: string
}

/**
 * Create a `Product` node
 * @param props Object containing Product schema properties as key/value pairs
 * @returns {Product} Product schema node
 */
export const product = (props: Omit<Product, 'type'> = {}): Product => ({
  ...compact(props),
  type: 'Product'
})

/**
 * A property-value pair.
 */
export interface PropertyValue extends Thing {
  type: 'PropertyValue'
  value: Node
  propertyID?: string
}

/**
 * Create a `PropertyValue` node
 * @param props Object containing PropertyValue schema properties as key/value pairs
 * @returns {PropertyValue} PropertyValue schema node
 */
export const propertyValue = (
  props: Omit<PropertyValue, 'type'>
): PropertyValue => ({
  ...compact(props),
  type: 'PropertyValue'
})

/**
 * A part of a successively published publication such as a periodical or publication
 * volume, often numbered.
 */
export interface PublicationIssue extends CreativeWork {
  type: 'PublicationIssue'
  issueNumber?: string | number
  pageEnd?: string | number
  pageStart?: string | number
  pagination?: string
}

/**
 * Create a `PublicationIssue` node
 * @param props Object containing PublicationIssue schema properties as key/value pairs
 * @returns {PublicationIssue} PublicationIssue schema node
 */
export const publicationIssue = (
  props: Omit<PublicationIssue, 'type'> = {}
): PublicationIssue => ({
  ...compact(props),
  type: 'PublicationIssue'
})

/**
 * A part of a successively published publication such as a periodical or multi-volume work.
 */
export interface PublicationVolume extends CreativeWork {
  type: 'PublicationVolume'
  pageEnd?: string | number
  pageStart?: string | number
  pagination?: string
  volumeNumber?: string | number
}

/**
 * Create a `PublicationVolume` node
 * @param props Object containing PublicationVolume schema properties as key/value pairs
 * @returns {PublicationVolume} PublicationVolume schema node
 */
export const publicationVolume = (
  props: Omit<PublicationVolume, 'type'> = {}
): PublicationVolume => ({
  ...compact(props),
  type: 'PublicationVolume'
})

/**
 * Inline, quoted content.
 */
export interface Quote extends Mark {
  type: 'Quote'
  cite?: Cite | string
}

/**
 * Create a `Quote` node
 * @param props Object containing Quote schema properties as key/value pairs
 * @returns {Quote} Quote schema node
 */
export const quote = (props: Omit<Quote, 'type'>): Quote => ({
  ...compact(props),
  type: 'Quote'
})

/**
 * A section quoted from somewhere else.
 */
export interface QuoteBlock extends Entity {
  type: 'QuoteBlock'
  content: Array<BlockContent>
  cite?: Cite | string
}

/**
 * Create a `QuoteBlock` node
 * @param props Object containing QuoteBlock schema properties as key/value pairs
 * @returns {QuoteBlock} QuoteBlock schema node
 */
export const quoteBlock = (props: Omit<QuoteBlock, 'type'>): QuoteBlock => ({
  ...compact(props),
  type: 'QuoteBlock'
})

/**
 * A software application.
 */
export interface SoftwareApplication extends CreativeWork {
  type: 'SoftwareApplication'
  softwareRequirements?: Array<SoftwareApplication>
  softwareVersion?: string
}

/**
 * Create a `SoftwareApplication` node
 * @param props Object containing SoftwareApplication schema properties as key/value pairs
 * @returns {SoftwareApplication} SoftwareApplication schema node
 */
export const softwareApplication = (
  props: Omit<SoftwareApplication, 'type'> = {}
): SoftwareApplication => ({
  ...compact(props),
  type: 'SoftwareApplication'
})

/**
 * A computational environment.
 */
export interface SoftwareEnvironment extends Thing {
  type: 'SoftwareEnvironment'
  name: string
  adds?: Array<SoftwareSourceCode>
  extends?: Array<SoftwareEnvironment>
  removes?: Array<SoftwareSourceCode>
}

/**
 * Create a `SoftwareEnvironment` node
 * @param props Object containing SoftwareEnvironment schema properties as key/value pairs
 * @returns {SoftwareEnvironment} SoftwareEnvironment schema node
 */
export const softwareEnvironment = (
  props: Omit<SoftwareEnvironment, 'type'>
): SoftwareEnvironment => ({
  ...compact(props),
  type: 'SoftwareEnvironment'
})

/**
 * Definition of a compute session, including its software and compute resource
 * requirements and status.
 */
export interface SoftwareSession extends Thing {
  type: 'SoftwareSession'
  clientsLimit?: number
  clientsRequest?: number
  cpuLimit?: number
  cpuRequest?: number
  dateEnd?: Date | string
  dateStart?: Date | string
  durationLimit?: number
  durationRequest?: number
  environment?: SoftwareEnvironment
  memoryLimit?: number
  memoryRequest?: number
  networkTransferLimit?: number
  networkTransferRequest?: number
  status?:
    | 'unknown'
    | 'starting'
    | 'started'
    | 'stopping'
    | 'stopped'
    | 'failed'
  timeoutLimit?: number
  timeoutRequest?: number
  volumeMounts?: Array<VolumeMount>
}

/**
 * Create a `SoftwareSession` node
 * @param props Object containing SoftwareSession schema properties as key/value pairs
 * @returns {SoftwareSession} SoftwareSession schema node
 */
export const softwareSession = (
  props: Omit<SoftwareSession, 'type'> = {}
): SoftwareSession => ({
  ...compact(props),
  type: 'SoftwareSession'
})

/**
 * Computer programming source code. Example: Full (compile ready) solutions, code snippet samples, scripts, templates.
 */
export interface SoftwareSourceCode extends CreativeWork {
  type: 'SoftwareSourceCode'
  codeRepository?: string
  codeSampleType?: string
  maintainers?: Array<Organization | Person>
  programmingLanguage?: string
  runtimePlatform?: Array<string>
  softwareRequirements?: Array<
    SoftwareSourceCode | SoftwareApplication | string
  >
  targetProducts?: Array<SoftwareApplication>
}

/**
 * Create a `SoftwareSourceCode` node
 * @param props Object containing SoftwareSourceCode schema properties as key/value pairs
 * @returns {SoftwareSourceCode} SoftwareSourceCode schema node
 */
export const softwareSourceCode = (
  props: Omit<SoftwareSourceCode, 'type'> = {}
): SoftwareSourceCode => ({
  ...compact(props),
  type: 'SoftwareSourceCode'
})

/**
 * A schema specifying constraints on a string node.
 */
export interface StringValidator extends Entity {
  type: 'StringValidator'
  maxLength?: number
  minLength?: number
  pattern?: string
}

/**
 * Create a `StringValidator` node
 * @param props Object containing StringValidator schema properties as key/value pairs
 * @returns {StringValidator} StringValidator schema node
 */
export const stringValidator = (
  props: Omit<StringValidator, 'type'> = {}
): StringValidator => ({
  ...compact(props),
  type: 'StringValidator'
})

/**
 * Strongly emphasised content.
 */
export interface Strong extends Mark {
  type: 'Strong'
}

/**
 * Create a `Strong` node
 * @param props Object containing Strong schema properties as key/value pairs
 * @returns {Strong} Strong schema node
 */
export const strong = (props: Omit<Strong, 'type'>): Strong => ({
  ...compact(props),
  type: 'Strong'
})

/**
 * Subscripted content.
 */
export interface Subscript extends Mark {
  type: 'Subscript'
}

/**
 * Create a `Subscript` node
 * @param props Object containing Subscript schema properties as key/value pairs
 * @returns {Subscript} Subscript schema node
 */
export const subscript = (props: Omit<Subscript, 'type'>): Subscript => ({
  ...compact(props),
  type: 'Subscript'
})

/**
 * Superscripted content.
 */
export interface Superscript extends Mark {
  type: 'Superscript'
}

/**
 * Create a `Superscript` node
 * @param props Object containing Superscript schema properties as key/value pairs
 * @returns {Superscript} Superscript schema node
 */
export const superscript = (props: Omit<Superscript, 'type'>): Superscript => ({
  ...compact(props),
  type: 'Superscript'
})

/**
 * A table.
 */
export interface Table extends CreativeWork {
  type: 'Table'
  rows: Array<TableRow>
}

/**
 * Create a `Table` node
 * @param props Object containing Table schema properties as key/value pairs
 * @returns {Table} Table schema node
 */
export const table = (props: Omit<Table, 'type'>): Table => ({
  ...compact(props),
  type: 'Table'
})

/**
 * A cell within a `Table`.
 */
export interface TableCell extends Entity {
  type: 'TableCell'
  content: Array<Node>
  cellType?: 'data' | 'header'
  colspan?: number
  name?: string
  rowspan?: number
}

/**
 * Create a `TableCell` node
 * @param props Object containing TableCell schema properties as key/value pairs
 * @returns {TableCell} TableCell schema node
 */
export const tableCell = (props: Omit<TableCell, 'type'>): TableCell => ({
  ...compact(props),
  type: 'TableCell'
})

/**
 * A row within a Table.
 */
export interface TableRow extends Entity {
  type: 'TableRow'
  cells: Array<TableCell>
  rowType?: 'header' | 'footer'
}

/**
 * Create a `TableRow` node
 * @param props Object containing TableRow schema properties as key/value pairs
 * @returns {TableRow} TableRow schema node
 */
export const tableRow = (props: Omit<TableRow, 'type'>): TableRow => ({
  ...compact(props),
  type: 'TableRow'
})

/**
 * A thematic break, such as a scene change in a story, a transition to another topic, or a new document.
 */
export interface ThematicBreak extends Entity {
  type: 'ThematicBreak'
}

/**
 * Create a `ThematicBreak` node
 * @param props Object containing ThematicBreak schema properties as key/value pairs
 * @returns {ThematicBreak} ThematicBreak schema node
 */
export const thematicBreak = (
  props: Omit<ThematicBreak, 'type'> = {}
): ThematicBreak => ({
  ...compact(props),
  type: 'ThematicBreak'
})

/**
 * A validator specifying constraints on an array of heterogeneous items.
 */
export interface TupleValidator extends Entity {
  type: 'TupleValidator'
  items?: Array<ValidatorTypes>
}

/**
 * Create a `TupleValidator` node
 * @param props Object containing TupleValidator schema properties as key/value pairs
 * @returns {TupleValidator} TupleValidator schema node
 */
export const tupleValidator = (
  props: Omit<TupleValidator, 'type'> = {}
): TupleValidator => ({
  ...compact(props),
  type: 'TupleValidator'
})

/**
 * A video file.
 */
export interface VideoObject extends MediaObject {
  type: 'VideoObject'
  caption?: string
  thumbnail?: ImageObject
  transcript?: string
}

/**
 * Create a `VideoObject` node
 * @param props Object containing VideoObject schema properties as key/value pairs
 * @returns {VideoObject} VideoObject schema node
 */
export const videoObject = (props: Omit<VideoObject, 'type'>): VideoObject => ({
  ...compact(props),
  type: 'VideoObject'
})

/**
 * Describes a volume mount from a host to container.
 */
export interface VolumeMount extends Thing {
  type: 'VolumeMount'
  mountDestination: string
  mountOptions?: Array<string>
  mountSource?: string
  mountType?: string
}

/**
 * Create a `VolumeMount` node
 * @param props Object containing VolumeMount schema properties as key/value pairs
 * @returns {VolumeMount} VolumeMount schema node
 */
export const volumeMount = (props: Omit<VolumeMount, 'type'>): VolumeMount => ({
  ...compact(props),
  type: 'VolumeMount'
})

/**
 * Union type for valid block content.
 */
export type BlockContent =
  | CodeBlock
  | CodeChunk
  | Heading
  | List
  | ListItem
  | MathBlock
  | Paragraph
  | QuoteBlock
  | Table
  | ThematicBreak

/**
 * All type schemas that are derived from CodeBlock
 */
export type CodeBlockTypes = CodeBlock | CodeChunk

/**
 * All type schemas that are derived from CodeFragment
 */
export type CodeFragmentTypes = CodeFragment | CodeExpression

/**
 * All type schemas that are derived from Code
 */
export type CodeTypes =
  | Code
  | CodeBlock
  | CodeChunk
  | CodeExpression
  | CodeFragment

/**
 * All type schemas that are derived from CreativeWork
 */
export type CreativeWorkTypes =
  | CreativeWork
  | Article
  | AudioObject
  | Collection
  | Datatable
  | Figure
  | ImageObject
  | MediaObject
  | Periodical
  | PublicationIssue
  | PublicationVolume
  | SoftwareApplication
  | SoftwareSourceCode
  | Table
  | VideoObject

/**
 * All type schemas that are derived from Entity
 */
export type EntityTypes =
  | Entity
  | ArrayValidator
  | Article
  | AudioObject
  | BooleanValidator
  | Brand
  | Cite
  | CiteGroup
  | Code
  | CodeBlock
  | CodeChunk
  | CodeError
  | CodeExpression
  | CodeFragment
  | Collection
  | ConstantValidator
  | ContactPoint
  | CreativeWork
  | Datatable
  | DatatableColumn
  | Date
  | Delete
  | Emphasis
  | EnumValidator
  | Figure
  | Function
  | Grant
  | Heading
  | ImageObject
  | Include
  | IntegerValidator
  | Link
  | List
  | ListItem
  | Mark
  | Math
  | MathBlock
  | MathFragment
  | MediaObject
  | MonetaryGrant
  | NumberValidator
  | Organization
  | Paragraph
  | Parameter
  | Periodical
  | Person
  | Product
  | PropertyValue
  | PublicationIssue
  | PublicationVolume
  | Quote
  | QuoteBlock
  | SoftwareApplication
  | SoftwareEnvironment
  | SoftwareSession
  | SoftwareSourceCode
  | StringValidator
  | Strong
  | Subscript
  | Superscript
  | Table
  | TableCell
  | TableRow
  | ThematicBreak
  | Thing
  | TupleValidator
  | Variable
  | VideoObject
  | VolumeMount

/**
 * All type schemas that are derived from Grant
 */
export type GrantTypes = Grant | MonetaryGrant

/**
 * Union type for valid inline content.
 */
export type InlineContent =
  | null
  | boolean
  | number
  | string
  | CodeFragment
  | CodeExpression
  | Delete
  | Emphasis
  | ImageObject
  | Link
  | MathFragment
  | Quote
  | Strong
  | Subscript
  | Superscript
  | Cite
  | CiteGroup

/**
 * All type schemas that are derived from Mark
 */
export type MarkTypes =
  | Mark
  | Delete
  | Emphasis
  | Quote
  | Strong
  | Subscript
  | Superscript

/**
 * All type schemas that are derived from Math
 */
export type MathTypes = Math | MathBlock | MathFragment

/**
 * All type schemas that are derived from MediaObject
 */
export type MediaObjectTypes =
  | MediaObject
  | AudioObject
  | ImageObject
  | VideoObject

/**
 * Union type for all valid nodes.
 */
export type Node =
  | null
  | boolean
  | number
  | string
  | Array<any>
  | { [key: string]: any }
  | Entity

/**
 * All type schemas that are derived from NumberValidator
 */
export type NumberValidatorTypes = NumberValidator | IntegerValidator

/**
 * All type schemas that are derived from Thing
 */
export type ThingTypes =
  | Thing
  | Article
  | AudioObject
  | Brand
  | Collection
  | ContactPoint
  | CreativeWork
  | Datatable
  | DatatableColumn
  | Figure
  | Grant
  | ImageObject
  | MediaObject
  | MonetaryGrant
  | Organization
  | Periodical
  | Person
  | Product
  | PropertyValue
  | PublicationIssue
  | PublicationVolume
  | SoftwareApplication
  | SoftwareEnvironment
  | SoftwareSession
  | SoftwareSourceCode
  | Table
  | VideoObject
  | VolumeMount

/**
 * Union type for all validator types.
 */
export type ValidatorTypes =
  | ConstantValidator
  | EnumValidator
  | BooleanValidator
  | NumberValidator
  | IntegerValidator
  | StringValidator
  | ArrayValidator
  | TupleValidator

/**
 * All type schemas that are derived from Variable
 */
export type VariableTypes = Variable | Parameter
